import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mail-icon_96f0a0756f8a002759b13f81780d0866",
  "use": "mail-icon_96f0a0756f8a002759b13f81780d0866-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"mail-icon_96f0a0756f8a002759b13f81780d0866\">\n<path d=\"M15.5 1.5C15.5 0.675 14.825 0 14 0H2C1.175 0 0.5 0.675 0.5 1.5V10.5C0.5 11.325 1.175 12 2 12H14C14.825 12 15.5 11.325 15.5 10.5V1.5ZM14 1.5L8 5.25L2 1.5H14ZM14 10.5H2V3L8 6.75L14 3V10.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol